import React from 'react';
import { DeleteIcon } from '../icons/delete-icon';
import { EditIcon } from '../icons/edit-icon';
import { Select, Flag as ReportIcon } from '@wix/wix-ui-icons-common/on-stage';
import { ActionsMenuLayout } from 'wix-ui-tpa/cssVars';
import { HorizontalDivider } from '../dividers';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { classes, st } from './actions-menu-items-desktop.st.css';
import styles from './actions-menu-items-desktop.scss';
import { ACTIONS_MENU_DELETE_BTN, ACTIONS_MENU_EDIT_BTN, ACTIONS_MENU_SHARE_BTN, ACTIONS_MENU_MARK_BTN, ACTIONS_MENU_REPORT_BTN, } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { CopyLinkIcon } from '../icons/copy-link-icon';
import { getMarkedCommentIcon } from '../../../common/utils/get-marked-comment-icon';
import { usePreloadEditorPlugins } from '../../hooks/use-preload-editor-plugins';
const ActionsMenuItemsDesktop = ({ share, report, edit, mark, delete: deleteAction, shouldAutofocus, }) => {
    const { blackAndWhiteModals, hideActionMenusIcons, markLabels } = useConfiguration();
    const preloadPlugins = usePreloadEditorPlugins();
    const t = useTranslate();
    const isBw = blackAndWhiteModals === true;
    const markActionLabel = mark?.isMarked
        ? markLabels?.unmarkActionLabel || t('comment-actions.unmark')
        : markLabels?.markActionLabel || t('comment-actions.mark');
    const MarkIcon = getMarkedCommentIcon(markLabels?.icon) || Select;
    const beforeDivider = [
        share && (React.createElement(ActionsMenuLayout.Item, { prefixIcon: !hideActionMenusIcons && React.createElement(CopyLinkIcon, { "data-hook": ACTIONS_MENU_SHARE_BTN }), content: t('comment-actions.copy-link'), onClick: share })),
        report && (React.createElement(ActionsMenuLayout.Item, { prefixIcon: !hideActionMenusIcons && React.createElement(ReportIcon, { "data-hook": ACTIONS_MENU_REPORT_BTN }), content: t('comment-actions.report'), onClick: report })),
        edit && (React.createElement(ActionsMenuLayout.Item, { prefixIcon: !hideActionMenusIcons && React.createElement(EditIcon, { "data-hook": ACTIONS_MENU_EDIT_BTN }), content: t('comment-actions.edit'), onClick: edit })),
        mark && (React.createElement(ActionsMenuLayout.Item, { prefixIcon: !hideActionMenusIcons && React.createElement(MarkIcon, { "data-hook": ACTIONS_MENU_MARK_BTN }), content: markActionLabel, onClick: mark.action })),
    ].filter(Boolean);
    const afterDivider = [
        deleteAction && (React.createElement(ActionsMenuLayout.Item, { prefixIcon: !hideActionMenusIcons && React.createElement(DeleteIcon, { "data-hook": ACTIONS_MENU_DELETE_BTN }), content: t('comment-actions.delete'), onClick: deleteAction })),
    ].filter(Boolean);
    const items = [
        ...beforeDivider,
        Boolean(beforeDivider.length && afterDivider.length) && (React.createElement(HorizontalDivider, { className: styles.divider, type: isBw ? 'black' : 'default' })),
        ...afterDivider,
    ].filter(Boolean);
    if (items.length === 0) {
        return null;
    }
    // The ActionsMenuLayout doesn't tolerate non react elements, so we do filtering before
    return (React.createElement("div", { className: styles.container, onMouseEnter: () => {
            edit && preloadPlugins();
        } },
        React.createElement(ActionsMenuLayout, { className: st(classes.root, { theme: !isBw, blackAndWhite: isBw }), focusedIndex: shouldAutofocus ? 0 : undefined }, items)));
};
export default ActionsMenuItemsDesktop;
//# sourceMappingURL=actions-menu-items-desktop.js.map